$('.autoplayann').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows:false,
});


$(' .slick-sliderr').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
  arrows:false,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow:4 ,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$(' .shop-by-zodiac').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow:4 ,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



$(' .slick-sliderrw').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow:4 ,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$(' .tumble-slide').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow:4 ,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$(' .pendats-slide').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow:4 ,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



document.addEventListener("scroll", function onScroll() {
  const section = document.querySelector(".swiper-wrappersss");
  if (section) {
    const rect = section.getBoundingClientRect();
    if (rect.top <= window.innerHeight && rect.bottom >= 0) {
      // Section is in the viewport
      $(section).slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2.4,
              slidesToScroll: 1,
            },
          },
        ],
      });

      // Remove the scroll event listener to avoid re-initialization
      document.removeEventListener("scroll", onScroll);
    }
  }
});




$(' .rough-stones').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1000,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow:4 ,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// Select all elements with class 'copyBtn'
const copyButtons = document.querySelectorAll('.copyBtn');

copyButtons.forEach(button => {
    button.addEventListener('click', function() {
        // Get the text from the associated <p> tag
        const textToCopy = this.previousElementSibling.innerText; // this is the <p> with class 'textToCopy'
        
        // Create a temporary input element to copy the text
        const tempInput = document.createElement('input');
        tempInput.value = textToCopy;
        document.body.appendChild(tempInput);
        
        // Select and copy the text
        tempInput.select();
        document.execCommand('copy');
        
        // Remove the temporary input element
        document.body.removeChild(tempInput);
        
        // Get the corresponding 'copiedMessage' and show the 'Copied!' message
        const copiedMessage = this.nextElementSibling; // this is the <p> with class 'copiedMessage'
        copiedMessage.innerText = 'Copied!';
        copiedMessage.style.display = 'block';

        // Optionally, hide the message after a few seconds
        setTimeout(() => {
            copiedMessage.style.display = 'none';
        }, 2000); // 2 seconds
    });
});
